/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { StyledStack } from 'src/luis/verticals/getStartedGuide/components/GetStartedList';

const messages = defineMessages({
    trainAndTestItemBody: {
        id: 'portal.getStartedList.trainAndTestItemBody',
        defaultMessage: 'After you labeled example data, you are ready train your app.'
    },
    trainAndTestStepOneStart: {
        id: 'portal.getStartedList.trainAndTestStepOneStart',
        defaultMessage: 'Use the Train button to '
    },
    trainAndTestStepOneEnd: {
        id: 'portal.getStartedList.trainAndTestStepOneEnd',
        defaultMessage: 'train your app.'
    },
    trainAndTestSteptwoStart: {
        id: 'portal.getStartedList.trainAndTestSteptwoStart',
        defaultMessage: 'Use the '
    },
    trainAndTestSteptwoEnd: {
        id: 'portal.getStartedList.trainAndTestSteptwoEnd',
        defaultMessage: ' to see how your model scores specific utterances.'
    },
    trainAndTestSteptwoMid: {
        id: 'portal.getStartedList.trainAndTestSteptwoMid',
        defaultMessage: 'test panel'
    },
    trainAndTestStepThreeStart: {
        id: 'portal.getStartedList.trainAndTestStepThreeStart',
        defaultMessage: 'Review the '
    },
    trainAndTestStepThreeMid: {
        id: 'portal.getStartedList.trainAndTestStepThreeMid',
        defaultMessage: 'Dashboard'
    },
    trainAndTestStepThreeEnd: {
        id: 'portal.getStartedList.trainAndTestStepThreeEnd',
        defaultMessage: ' page to improve your app\'s overall accuracy.'
    }
});

const urls = {
    trainApp: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-how-to-train',
    testPanel: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-interactive-test',
    dashboard: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-how-to-use-dashboard'
};

export const TrainTestListItem = () => {
    const { localize } = useLocalization();

    return (
        <StyledStack style={{ paddingLeft: 40 }}>
            {localize(messages.trainAndTestItemBody)}
            <ol style={{ listStylePosition: 'inside', marginTop: 18 }}>
                <li>
                    <span>
                        {localize(messages.trainAndTestStepOneStart)}
                        <a href={urls.trainApp}>{localize(messages.trainAndTestStepOneEnd)}</a>
                    </span>
                </li>
                <li>
                    <span>
                        {localize(messages.trainAndTestSteptwoStart)}
                        <a href={urls.testPanel}>{localize(messages.trainAndTestSteptwoMid)}</a>
                        {localize(messages.trainAndTestSteptwoEnd)}
                    </span>
                </li>
                <li>
                    <span>
                        {localize(messages.trainAndTestStepThreeStart)}
                        <a href={urls.dashboard}>{localize(messages.trainAndTestStepThreeMid)}</a>
                        {localize(messages.trainAndTestStepThreeEnd)}
                    </span>
                </li>
            </ol>
        </StyledStack>
    );
};
